/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { deleteProject } from "../../App/actions/projectActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class DeleteProject extends Component {
  state = {
    geo_project: {},
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.project.geo_project._id !== prevState.geo_project._id) {
      return {
        geo_project: nextProps.project.geo_project,
      };
    } else return null;
  }

  handleSubmit = () => {
    const { folder_id_selected, geo_project_pinned_list } = this.props.project;
    const { geo_project } = this.state;

    const is_project_inside_pinned = geo_project_pinned_list?.some(
      (pinned_project) => pinned_project?._id === geo_project?._id
    );

    let key;
    if (is_project_inside_pinned && !!folder_id_selected) {
      key = "geo_project_list_child&geo_project_pinned_list";
    } else if (is_project_inside_pinned) {
      key = "geo_project_pinned_list";
    } else if (!!folder_id_selected) {
      key = "geo_project_list_child";
    } else {
      key = "geo_project_list";
    }

    const body = {
      geo_project_id: geo_project?._id,
      key,
    };
    this.props.deleteProject(body);
    this.props.toggleDelete();
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const { geo_project } = this.state;

    //global props
    const { loadingProcess } = this.props.project;

    //content
    let itemContent;
    let buttonContent;
    if (loadingProcess) {
      buttonContent = (
        <button className="button_big background_grey">
          {dict["Deleting"][language]}...
        </button>
      );
    } else {
      buttonContent = (
        <button
          className="button_big background_red"
          onClick={this.handleSubmit}
          data-mapid="clickDeleteModal"
        >
          {dict["Delete"][language]}
        </button>
      );
    }
    itemContent = (
      <main>
        <div className="text_bold margin_bottom">
          {dict["Are you sure you will delete this project?"][language]}
          <br />
        </div>
        <p className="text_bold sub_color margin_bottom_extra">
          {
            dict[
              "This Project will be kept in the Recovery place for 30 days before being permanently deleted automatically"
            ][language]
          }
        </p>
        <p className="margin_bottom_extra">
          <span className="text_bold sub_color">
            {dict["Project Name"][language]}:{" "}
          </span>
          <span className="text_bold">{geo_project?.name}</span>
        </p>

        <section className="text_center">{buttonContent}</section>
      </main>
    );
    return <div>{itemContent}</div>;
  }
}

const mapStateToProps = (state) => ({
  project: state.project,
  auth: state.auth,
});

export default connect(mapStateToProps, { deleteProject })(DeleteProject);
